var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"flipdish-menu","data-restaurant":"fd8933"}},[_c('div',{staticStyle:{"font-size":"3.5vh","position":"absolute","left":"50%","top":"50%","transform":"translate(-50%, -50%)"}},[_vm._v(_vm._s(_vm.getTranslation('loading')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-296f31e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeliveryPage.vue
// module id = null
// module chunks = 